module.exports = __webpack_public_path__ + "img/good2.e5542ba2.svg";